<template>
     <el-dialog :title="title" :visible.sync="open" width="80%" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <template v-if="title == '修改工单基本信息'">
          <el-form-item label="负责人" prop="userId">
            <el-select v-model="form.userName" filterable remote reserve-keyword placeholder="请输入负责人"
              :remote-method="remoteMethod" :loading="remoteLoading" @change="userChange($event, 1)">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目文件" prop="files">
            <file-upload v-model="form.files" :limit="9" />
          </el-form-item>
        </template>
        <template v-if="title == '填写延期原因'">
          <el-form-item label="延期原因" prop="extensionMessage">
            <el-input v-model="form.extensionMessage" placeholder="请输入延期原因" />
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
</template>

<script>
import {  updateOrder, listPersonnel  } from '@/api/workOrder';
import Cookies from 'js-cookie'
export default {
data() {
  return {
    title: '',
    open: false,
     // 表单参数
     form: {},
    // 表单校验
    rules: {
    },
    remoteLoading: false,
      userList: [],
  }
},
methods: {
  showForm(record, title){
    this.open = true
    this.form = record
    this.title = title
  },
      // 取消按钮
      cancel() {
    this.open = false;
  },
  remoteMethod(query) {
      if (query !== '') {
        this.remoteloading = true;
        listPersonnel({
          pageNum: 1,
          pageSize: 999,
          name: query,
          companyId: Cookies.get('companyId')
        }).then((response) => {
          this.userList = response.rows;
          console.log(response.row)
          this.remoteloading = false;
        });

      } else {
        this.userList = [];
      }
    },
    userChange(e, type) {
      console.log(e, type)
      const selectedOption = this.userList.find(option => option.id === e);
      if (type == 1) {
        this.form.phone = selectedOption.phone
        this.form.userName = selectedOption.name
        this.form.userId = selectedOption.userId
      } else if (type == 2) {
        this.queryParams.userId = selectedOption.id
      }
    },
  submitForm() {
    this.$refs["form"].validate(valid => {
        if (valid) {
          updateOrder(this.form).then(response => {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.open = false;
            this.$emit('ok')
          });
        }
      });
  },
},
mounted() {

}
}
</script>

<style scoped>

</style>
